import {Form as MobxReactForm} from '@swipe-guide/clients-shared/utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

export const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'phoneNumber',
    rules: 'required|string'
  },
  {
    name: 'activationCode',
    rules: 'required|string'
  },
  {
    name: 'password',
    rules: 'required|string'
  },
  {
    name: 'passwordConfirm',
    rules: 'required|string'
  }
];

export default () => new MobxReactForm({fields}, {plugins});
